import React from 'react';
import { Link } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import css from '../box-introduction-info.scss';
export const LearnMoreLink = () => {
  return /*#__PURE__*/React.createElement(Link, {
    className: css.pinkLink,
    target: "_blank",
    rel: "noreferrer noopener",
    "data-link": "toInAboxFromCartBoxPopup",
    to: APP_ROUTES.IN_A_BOX
  }, "Want to learn more?");
};